"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_sanofi/config.js"));

var _Nugget = _interopRequireDefault(require("./Nugget.scss"));

var _DrupalMazarsCertNugget = _interopRequireDefault(require("./DrupalMazarsCertNugget.scss"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _TerminNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/TerminNugget"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _KESI2Helper = require("../../../../KESI2/KESI2Helper");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _FeedbackService = require("../../../../KESI2/Services/FeedbackService");

var _ArrayHelper = require("../../../../helpers/ArrayHelper");

var _MazarsCertNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/MazarsCertNugget"));

var _core = require("@material-ui/core");

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _RegisterInstance = _interopRequireDefault(require("../../../../KESI2/Services/RegisterInstance"));

var _HttpRequest = require("../../../../utils/HttpRequest");

var _BuildConstants = require("../../../../utils/BuildConstants");

var _MuiAlertHelper = require("../../../../helpers/MuiAlertHelper");

var _DrupalNuggetStrings = require("./DrupalNuggetStrings");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOM_PREFIX = 'certContainer_';
var DOCUMENT_ID = 'documentId_';

var DrupalMazarsCertNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalMazarsCertNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalMazarsCertNugget);

  function DrupalMazarsCertNugget(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, DrupalMazarsCertNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "sortById", function (contents) {
      return contents.sort(function (content1, content2) {
        return content1.id - content2.id;
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setFirstName", function (evt) {
      _this.setState({
        firstName: evt.target.value
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setLastName", function (evt) {
      _this.setState({
        lastName: evt.target.value
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkNames", function () {
      var firstName = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.MAZARS_CERT_FIRST_NAME) || _this.state.firstName;

      var lastName = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.MAZARS_CERT_LAST_NAME) || _this.state.lastName;

      _this.setState({
        error: null
      });

      var okButton = {
        label: 'Ja',
        callback: function callback() {
          _this.getCertificate();
        }
      };
      var cancelButton = {
        label: 'Nein'
      };
      (0, _MuiAlertHelper.showWideAlertHtml)((0, _DrupalNuggetStrings.getString)('MAZARS_CERT_CHECK_NAME_TEXT', [firstName, lastName]), (0, _DrupalNuggetStrings.getString)('MAZARS_CERT_CHECK_NAME_TITLE'), true, [cancelButton, okButton]);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getCertificate", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var certificatePath, certificateDate, firstName, lastName, certSent, userProfile, name, url, charToUse, token, result, data;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              certificatePath = "public.".concat(_config["default"].pdfFeature ? _config["default"].pdfFeature : _config["default"].requiredFeature, ".newCertificateDate");
              certificateDate = _DataStore["default"].getElementByPathImmediately(certificatePath);
              firstName = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.MAZARS_CERT_FIRST_NAME) || _this.state.firstName;
              lastName = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.MAZARS_CERT_LAST_NAME) || _this.state.lastName;
              certSent = _this.state.data[_DataStore.DATA_STORE_PATHS.MAZARS_CERT_SENT];
              userProfile = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.USER_PROFILE);
              name = "".concat(firstName, " ").concat(lastName);
              url = certSent ? _config["default"].certificatePdfCreationUrl : _config["default"].certificatePdfSendUrl;
              charToUse = certSent ? '?' : '&';
              _context.prev = 9;
              _context.next = 12;
              return _RegisterInstance["default"].getAccessToken('eCloud:read');

            case 12:
              token = _context.sent;
              _context.next = 15;
              return (0, _HttpRequest.httpGet)(_BuildConstants.PDF_HOST + '/' + url + charToUse + "name=".concat(name, "&date=").concat(certificateDate, "&feature=").concat(_config["default"].pdfFeature, "&email=").concat(userProfile.email), {}, {}, 30000, 2, 'Bearer ' + token);

            case 15:
              result = _context.sent;

              if (result && result.data && result.data.url) {
                if (_DeviceInfoHelper["default"].isBrowser()) {
                  window.open(_BuildConstants.PDF_HOST + result.data.url, '_blank');
                } else {
                  window.open(_BuildConstants.PDF_HOST + result.data.url, '_system');
                }
              }

              if (certSent) {
                _context.next = 24;
                break;
              }

              data = {};
              data[_DataStore.DATA_STORE_PATHS.MAZARS_CERT_FIRST_NAME] = firstName;
              data[_DataStore.DATA_STORE_PATHS.MAZARS_CERT_LAST_NAME] = lastName;
              data[_DataStore.DATA_STORE_PATHS.MAZARS_CERT_SENT] = true;
              _context.next = 24;
              return _DataStore["default"].setData(data);

            case 24:
              _context.next = 29;
              break;

            case 26:
              _context.prev = 26;
              _context.t0 = _context["catch"](9);

              _this.setState({
                error: (0, _DrupalNuggetStrings.getString)('MAZARS_CERT_GET_CERT_ERROR', [_context.t0])
              });

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9, 26]]);
    })));
    _this.state = _objectSpread({
      // the nugget will be put there on a magic way by Reflux and props.id which is given in the constructor
      firstName: '',
      lastName: ''
    }, _this.state);

    _this.props.registerNugget(_this.props.id, _MazarsCertNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    _this.setDataStorePaths([_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES, _DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA, _DataStore.DATA_STORE_PATHS.MAZARS_CERT_SENT]);

    return _this;
  }

  (0, _createClass2["default"])(DrupalMazarsCertNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.registerNuggetPosition(this.props.id, _MazarsCertNugget["default"].CLASS, this.getDomId()); // this.getIcsContents()

      if (this.props.inListContainer) {
        this.props.setBackButtonFunc(this.props.goUpFunc);
      }

      this.props.markAsRead(this.props.id);
    }
  }, {
    key: "getNugget",

    /**
     * @returns {TerminNugget}
     */
    value: function getNugget() {
      return this.state.content[this.props.id];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var nugget = this.getNugget();
      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] || nugget.active : nugget.active;
      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';
      var likes = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_LIKES) || [];
      var likeIndex = likes.indexOf(this.props.id);
      var allLikes = this.state.data[_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES];
      var currentLikesForId = allLikes && allLikes["".concat(this.props.id)] ? allLikes["".concat(this.props.id)] : 0;

      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT);

      var storedFirstName = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.MAZARS_CERT_FIRST_NAME);

      var storedLastName = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.MAZARS_CERT_LAST_NAME);

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "certContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: this.getDomId(),
        style: this.props.inSwipeContainer || this.props.inListContainer || this.props.inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, _config["default"].showNuggetIcons ? this.props.renderIcon(nugget) : null, /*#__PURE__*/_react["default"].createElement("div", null, isAuthor && !nugget.isPublished && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          padding: '10px',
          color: 'red'
        }
      }, "Content unver\xF6ffentlicht"), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'title'
      }, (0, _DrupalNuggetStrings.getString)('MAZARS_CERT_YOUR_CERT')), nugget.info ? /*#__PURE__*/_react["default"].createElement("div", {
        className: 'info',
        dangerouslySetInnerHTML: {
          __html: nugget.info
        }
      }) : null, this.state.error ? /*#__PURE__*/_react["default"].createElement("p", {
        className: _DrupalMazarsCertNugget["default"].error
      }, this.state.error) : null, /*#__PURE__*/_react["default"].createElement("p", null, (0, _DrupalNuggetStrings.getString)('MAZARS_CERT_WARNING')), /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        required: true,
        id: "first-name-required",
        label: (0, _DrupalNuggetStrings.getString)('FIRST_NAME'),
        value: storedFirstName || this.state.firstName,
        margin: "dense",
        className: "".concat(_DrupalMazarsCertNugget["default"].textfield, " textfield"),
        onChange: this.setFirstName,
        disabled: storedFirstName && storedFirstName.length > 0
      }), /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        required: true,
        id: "standard-required",
        label: (0, _DrupalNuggetStrings.getString)('LAST_NAME'),
        margin: "dense",
        value: storedLastName || this.state.lastName,
        className: "".concat(_DrupalMazarsCertNugget["default"].textfield, " textfield"),
        onChange: this.setLastName,
        disabled: storedLastName && storedLastName.length > 0
      }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
        onClick: this.state.data[_DataStore.DATA_STORE_PATHS.MAZARS_CERT_SENT] ? this.getCertificate : this.checkNames,
        variant: "contained",
        className: _DrupalMazarsCertNugget["default"].button,
        disabled: (this.state.firstName === '' || this.state.lastName === '') && !storedLastName && !storedFirstName
      }, this.state.data[_DataStore.DATA_STORE_PATHS.MAZARS_CERT_SENT] ? (0, _DrupalNuggetStrings.getString)('MAZARS_CERT_GET_CERT') : (0, _DrupalNuggetStrings.getString)('MAZARS_CERT_CREATE_CERT'))), _config["default"].hasLikeFunctionalityForNuggets && !this.props.inSwipeContainer && !this.props.inListContainer && !this.props.inGalleryContainer ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeContainer
      }, _config["default"].useTargetIcons ? /*#__PURE__*/_react["default"].createElement("img", {
        className: _Nugget["default"].svgLikeButton,
        onClick: function onClick() {
          return _this2.props.setLike();
        },
        src: likeIndex < 0 ? _config["default"].likeInactive : _config["default"].likeActive
      }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        onClick: function onClick() {
          return _this2.props.setLike();
        },
        className: likeIndex < 0 ? _Nugget["default"].likeButton : _Nugget["default"].likeButtonActivated,
        name: 'thumbs-o-up'
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeText
      }, "".concat(currentLikesForId, " ").concat(currentLikesForId === 1 ? 'Like' : 'Likes'))) : null);
    }
  }]);
  return DrupalMazarsCertNugget;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalMazarsCertNugget;
DrupalMazarsCertNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  regionCode: _propTypes["default"].string,
  setBackButtonFunc: _propTypes["default"].func,
  closeTile: _propTypes["default"].func,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  renderIcon: _propTypes["default"].func.isRequired,
  setLike: _propTypes["default"].func
};
DrupalMazarsCertNugget.defaultProps = {
  id: null
};